<template>
    <rkm-area
        no-margin-top
        :title="title ? title : 'Sinais vitais'"
    >
        <rkm-row>
            <rkm-col>
                <Item
                    :get-value="() => data.pressaoArterial"
                    append-text="mmHg"
                    label="Pressão arterial"
                />
            </rkm-col>

            <rkm-col>
                <Item
                    :get-value="() => data.frequenciaRespiratoria"
                    append-text="mpm"
                    label="Frequência respiratória"
                />
            </rkm-col>

            <rkm-col>
                <Item
                    :get-value="() => data.frequenciaCardiaca"
                    append-text="bpm"
                    label="Frequência cardíaca"
                />
            </rkm-col>

            <rkm-col>
                <Item
                    :get-value="() => data.temperatura"
                    append-text="ºC"
                    label="Temperatura"
                />
            </rkm-col>

            <rkm-col>
                <Item
                    :get-value="() => data.saturacaoO2"
                    append-text="%"
                    label="Saturação de 02"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        data: {type: Object},
        title: {type: String, default: null},
    },
}
</script>